export function shallowCompareInterfaces<T extends object>(left: T, right: T): boolean {
	const leftKeys = Object.keys(left);

	if (leftKeys.length !== Object.keys(right).length) {
		return false;
	}

	for (const key of leftKeys as (keyof T)[]) {
		if (left[key] !== right[key]) {
			return false;
		}
	}

	return true;
}

export function deepCompareInterfaces<T>(left: T, right: T): boolean {
	const deepEqual = (a: any, b: any): boolean => {
		if (a === b) return true;

		if (a == null || b == null) return false;

		if (a instanceof Date && b instanceof Date) {
			return a.getTime() === b.getTime();
		}

		if (Array.isArray(a) && Array.isArray(b)) {
			if (a.length !== b.length) return false;
			return a.every((item, i) => deepEqual(item, b[i]));
		}

		if (typeof a === "object" && typeof b === "object") {
			const aKeys = Object.keys(a);
			const bKeys = Object.keys(b);
			if (aKeys.length !== bKeys.length) return false;

			return aKeys.every(key => deepEqual(a[key], b[key]));
		}

		return false;
	}

	return deepEqual(left, right);
}